'use client';
import { sprinkles } from '@/style/landingPage/theme.css';
import * as styles from'@/style/landingPage/styles.css';

import { useEffect, useRef, useState,  } from 'react';

import { ChevronLeft, ChevronRight } from 'lucide-react';
import LatestNewsCard from './LatestNewsCard';

import SkeletonCards from '../Skeleton';

export default function LatestNewsCards({result, loading}: {result: {link: string, newWindow: boolean, heading: string, summary: string, image: string}[], loading: boolean}) {
  const newsCard = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [cardWidth, setCardWidth] = useState(0);

  useEffect(() => {
    if (newsCard.current) {
      const width = newsCard.current.offsetWidth;
      setCardWidth(width);
    }
  }, [result]);

  const handlePrev = () => {
    setActiveIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => Math.min(result.length - 1, prev + 1));
  };

  const handleDotClick = (index: number) => {
    setActiveIndex(index);
  };

  return (
  <div style={{ position: 'relative' }}>
    <div className={styles.newsGrid} style={{ transform: `translateX(-${activeIndex * (cardWidth + 20)}px)` }}>
      {(loading && !result.length) ? (
        [1,2,3].map((item) =>(
        <SkeletonCards
          key={item}
          amount={1}
          md={4}
          rowGutter={true}
          cx={{ rowGap: '7' }}
          SkeletonItems={{
            cx: { flexDirection: 'column', rowGap: '2', display: { mobile: 'flex', tablet: 'none' } },
            items: [
              { variant: 'rounded', height: 260, width: '100%', sx: { bgcolor: 'lightgrey' } },
              { variant: 'rounded', height: 20, width: '75%', sx: { bgcolor: 'lightgrey' } },
              { variant: 'rounded', height: 30, width: '75%', sx: { bgcolor: 'lightgrey' } },
            ],
          }}
          />
        ))
          
      )
      : (
      result.map((news: {link: string, newWindow: boolean, heading: string, summary: string, image: string}, i) => 
        (i === 0 ? (
        <div ref={newsCard} key={i}>
          <LatestNewsCard
            key={i}
            link={news.link}
            newWindow={news.newWindow}
            heading={news.heading}
            summary={news.summary}
            image={news.image}
          />
        </div>
        ) : (
        <LatestNewsCard
          key={i}
          link={news.link}
          newWindow={news.newWindow}
          heading={news.heading}
          summary={news.summary}
          image={news.image}
        />
        )
      )))
    }
    </div>
      
    {/* Mobile Navigation Controls */}
    <div className={sprinkles({ display: { mobile: 'flex', tablet: 'none' }, justifyContent: 'center', alignItems: 'center', gap: 'lg', marginTop: 'fifty' })}>
      <button
        onClick={handlePrev}
        disabled={activeIndex === 0}
        className={sprinkles({ backgroundColor: 'orange', color: 'navy', display: 'flex', alignItems: 'center', justifyContent: 'center' })}
        style={{
          border: 'none',
          borderRadius: '50%',
          width: '56px',
          height: '56px',
          cursor: activeIndex === 0 ? 'not-allowed' : 'pointer',
          opacity: activeIndex === 0 ? 0.5 : 1,
        }}
      >
        <ChevronLeft size={16} />
      </button>
        
      {/* Dots */}
      <div className={sprinkles({ display: 'flex', gap: 'lg' })}>
        {result.map((_, index) => (
          <button
            key={index}
            onClick={() => handleDotClick(index)}
            style={{
              width: '16px',
              height: '16px',
              borderRadius: '50%',
              border: '1px solid #0b162a',
              backgroundColor: activeIndex === index ? '#0b162a' : 'transparent',
              cursor: 'pointer',
              padding: 0,
            }}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
        
      <button
        onClick={handleNext}
        disabled={activeIndex === result.length - 1}
        className={sprinkles({ backgroundColor: 'orange', color: 'navy', display: 'flex', alignItems: 'center', justifyContent: 'center' })}
        style={{
          border: 'none',
          borderRadius: '50%',
          width: '56px',
          height: '56px',
          cursor: activeIndex === result.length - 1 ? 'not-allowed' : 'pointer',
          opacity: activeIndex === result.length - 1 ? 0.5 : 1,
        }}
      >
        <ChevronRight size={16} />
      </button>
    </div>
  </div>
  )
}